import { cn } from '@/lib/utils'
import { memo, useState } from 'react'

/** `public/assets/Pelgo-Hero 2.mp4` */
export const PELGO_HERO_VIDEO_SRC = '/assets/Pelgo-Hero%202.mp4'

type PelgoHeroBackgroundVideoProps = {
  className?: string
}

export const PelgoHeroBackgroundVideo = memo(function PelgoHeroBackgroundVideo({
  className,
}: PelgoHeroBackgroundVideoProps) {
  const [failed, setFailed] = useState(false)
  if (failed) return null

  return (
    <video
      autoPlay
      muted
      loop
      playsInline
      preload="auto"
      aria-hidden
      className={cn('absolute inset-0 -z-10 h-full w-full object-cover', className)}
      onError={() => setFailed(true)}
    >
      <source src={PELGO_HERO_VIDEO_SRC} type="video/mp4" />
    </video>
  )
})
